import React from 'react';

/**
 * VaultGrow Logo — two crossing pyramids (up + inverted), minimalist outline
 * Square with rounded corners, gray tones, transparent background
 */
export function VaultGrowLogo({ size = 36, borderRadius = 10 }) {
  return (
    <div style={{
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: `${borderRadius}px`,
      background: 'rgba(158,175,172,0.08)',
      border: '1px solid rgba(158,175,172,0.22)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}>
      <svg
        viewBox="0 0 32 32"
        width={size * 0.72}
        height={size * 0.72}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        {/* Pyramid pointing UP — apex top-center, base bottom */}
        <polygon
          points="16,3 2,29 30,29"
          fill="none"
          stroke="#9EAFAC"
          strokeWidth="1.6"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        {/* Pyramid pointing DOWN (inverted) — apex bottom-center, base top */}
        <polygon
          points="16,29 2,3 30,3"
          fill="none"
          stroke="#9EAFAC"
          strokeWidth="1.6"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
